const PersonaDesc = [
  {
    name: 'American Mosaic',
    cohort: 'Resource Constrained',
    socialMedia: ['Instagram'],
    descS: (
      <>
        American Mosaic are typically <b>younger adults</b> and often speak <b>English as a second language. </b>They
        strongly value their <b>cultural identity</b> and tend to embrace new experiences, showing an{' '}
        <b>openness and willingness to take risks.</b>
        <br />
        <br />
        Many in this group are single parents and face an elevated risk of <b>food insecurity, </b>often navigating
        financial and housing
      </>
    ),
    descL: (
      <>
        American Mosaic are typically <b>younger adults</b> and often speak <b>English as a second language. </b>They
        strongly value their <b>cultural identity</b> and tend to embrace new experiences, showing an{' '}
        <b>openness and willingness to take risks.</b>
        <br />
        <br />
        Many in this group are single parents and face an elevated risk of <b>food insecurity, </b>often navigating
        financial and housing constraints. They tend to have <b>lower formal education levels</b> and{' '}
        <b>higher unemployment rates.</b> More likely to live in a crowded home or apartment, they are often subject to
        environmental toxins as well as <b>public safety concerns.</b>
        <br />
        <br />
        They are at elevated risk for drug use, asthma, and obesity. Still, they are often{' '}
        <b>resourceful, tech savvy,</b> and <b>likely to</b> <b>adopt and sustain healthy behaviors</b> when given
        access to the right tools and supports. When they seek care, they are more likely to choose{' '}
        <b>community or retail clinics </b>as opposed to traditional primary care providers.
      </>
    )
  },
  {
    name: 'Rustic Landscapes',
    cohort: 'Resource Constrained',
    socialMedia: ['Facebook'],
    descS: (
      <>
        Traditional Individualists tend to <b>live in small households, often living alone or with one other person</b>.
        They often place a strong emphasis on <b>tradition and personal values,</b> with <b>faith</b> playing an
        important role in their lives. <br />
        <br />
        With <b>below-average educational attainment,</b> <b>limited broadband access, </b>and{' '}
        <b>low digital literacy</b>, this group can be at increased risk
      </>
    ),
    descL: (
      <>
        Traditional Individualists tend to <b>live in small households, often living alone or with one other person</b>.
        They often place a strong emphasis on <b>tradition and personal values,</b> with <b>faith</b> playing an
        important role in their lives. <br />
        <br />
        With <b>below-average educational attainment,</b> <b>limited broadband access, </b>and{' '}
        <b>low digital literacy</b>, this group can be at increased risk for social and technological{' '}
        <b>disconnection.</b>
        <br />
        <br />
        Many individuals, particularly older adults, may have a <b>higher risk of chronic health conditions</b> such as
        high blood pressure or heart disease. Some may also experience{' '}
        <b>challenges related to maintaining a healthy weight,</b> physical limitations, or an elevated risk for alcohol
        use disorder.
      </>
    )
  },
  {
    name: 'Independent Neighbors',
    cohort: 'Resource Constrained',
    socialMedia: ['Facebook', 'Instagram'],
    descS: (
      <>
        <b>Independent Neighbors</b> often include older adults, many of whom work in low-wage jobs but tend to manage
        their finances carefully and are less likely to apply for assistance such as short-term loans.
        <br />
        <br /> While they value their cultural heritage and faith community, they can be <b>isolated</b> – they are the
        group most likely to <b>live alone</b> and <b>most are unmarried.</b>
      </>
    ),
    descL: (
      <>
        <b>Independent Neighbors</b> often include older adults, many of whom work in low-wage jobs but tend to manage
        their finances carefully and are less likely to apply for assistance such as short-term loans.
        <br />
        <br /> While they value their cultural heritage and faith community, they can be <b>isolated</b> – they are the
        group most likely to <b>live alone</b> and <b>most are unmarried.</b>
        <br />
        <br />
        They have the <b>highest rate of SNAP eligibility</b> and experience an <b>elevated risk for obesity.</b> As
        older adults with limited digital literacy, they may <b>struggle to navigate the care system</b> and manage
        comorbidities such as diabetes.
      </>
    )
  },
  {
    name: 'Small-Town Strivers',
    cohort: 'Resource Constrained',
    socialMedia: ['Facebook'],
    descS: (
      <>
        Small-Town Strivers are generally <b>tech savvy</b> and eager to try new things, often{' '}
        <b>embracing risk and novelty.</b> However, with the <b>lowest college education rates</b> and almost half
        earning less than $30,000 per year, <b>money is tight.</b>
        <br />
        <br /> Many are single parents and often live in <b>crowded housing conditions.</b> They face some of the{' '}
      </>
    ),
    descL: (
      <>
        Small-Town Strivers are generally <b>tech savvy</b> and eager to try new things, often{' '}
        <b>embracing risk and novelty.</b> However, with the <b>lowest college education rates</b> and almost half
        earning less than $30,000 per year, <b>money is tight.</b>
        <br />
        <br /> Many are single parents and often live in <b>crowded housing conditions.</b> They face some of the{' '}
        <b>lowest rates of broadband access </b>and <b>health insurance coverage.</b> <br />
        <br />
        They are at-risk for <b>smoking and drug abuse,</b> struggle with <b>weight,</b> and have above-average risk for
        asthma and an elevated risk of depression.
        <br />
        <br />
        When they seek care, they are more likely to choose <b>community or retail clinics </b>as opposed to traditional
        primary care providers.
      </>
    )
  },
  {
    name: 'Working-Class Commuters',
    cohort: 'Resource Constrained',
    socialMedia: ['Facebook'],
    descS: (
      <>
        Working-Class Commuters tend to be <b>blue-collar workers.</b> <b>Living alone or in small families,</b> they
        earn lower-middle class salaries, which often require<b> tight budgeting and tradeoffs.</b>
        <br />
        <br />
        They appreciate <b>novelty</b> and are open to trying new things. <br />
        <br />
        Working-Class Commuters sometimes go <b>uninsured</b> but are
      </>
    ),
    descL: (
      <>
        Working-Class Commuters tend to be <b>blue-collar workers.</b> <b>Living alone or in small families,</b> they
        earn lower-middle class salaries, which often require<b> tight budgeting and tradeoffs.</b>
        <br />
        <br />
        They appreciate <b>novelty</b> and are open to trying new things. <br />
        <br />
        Working-Class Commuters sometimes go <b>uninsured</b> but are not at a high risk for chronic health conditions.
        However, their <b>smoking habits</b> could contribute to future health concerns down the line.
        <br />
        <br /> They also experience above average rates of <b>food insecurity</b> – likely influenced by cost-of-living
        pressures and limited access to healthy, affordable food options in the areas where they live.
      </>
    )
  },
  {
    name: 'Rooted Renters',
    cohort: 'Resource Constrained',
    socialMedia: ['Instagram'],
    descS: (
      <>
        Urban Anchors are deeply rooted in their <b>communities,</b> with strong <b>cultural and faith-based ties</b>{' '}
        that shape their daily lives. They are more likely to <b>rent rather than own a home</b> and often live in
        multi-unit or shared housing. <br />
        <br />
        Despite facing <b>systemic barriers,</b> including underinvestment in neighborhood
      </>
    ),
    descL: (
      <>
        Urban Anchors are deeply rooted in their <b>communities,</b> with strong <b>cultural and faith-based ties</b>{' '}
        that shape their daily lives. They are more likely to <b>rent rather than own a home</b> and often live in
        multi-unit or shared housing. <br />
        <br />
        Despite facing <b>systemic barriers,</b> including underinvestment in neighborhood infrastructure and higher
        exposure to <b>environmental and public safety risks,</b> they demonstrate strong connections to their cultural
        heritages and local communities.
        <br />
        <br /> Urban Anchors are more likely to <b>live</b> <b>alone</b> and to be <b>unmarried,</b> and they face
        elevated risks for <b>chronic conditions</b> and <b>alcohol use.</b> With lower rates of health insurance
        coverage, they often rely on <b>hospital </b>or <b>emergency care</b> as their primary access point for health
        services.
      </>
    )
  },
  {
    name: 'High Hopes',
    cohort: 'Resource Constrained',
    socialMedia: ['Instagram', 'Twitter'],
    descS: (
      <>
        High Hopes have the <b>smallest household sizes,</b> often <b>living alone</b> or with one other person. Some
        individuals in this group speak <b>English as a second language.</b>
        <br />
        <br />
        Despite <b>above average college education</b> rates, they <b>struggle financially</b> across the board.
        <br />
        <br /> Still, High Hopes are <b>highly motivated to seek out new things and explore other cultures.</b>
      </>
    ),
    descL: (
      <>
        High Hopes have the <b>smallest household sizes,</b> often <b>living alone</b> or with one other person. Some
        individuals in this group speak <b>English as a second language.</b>
        <br />
        <br />
        Despite <b>above average college education</b> rates, they <b>struggle financially</b> across the board.
        <br />
        <br /> Still, High Hopes are <b>highly motivated to seek out new things and explore other cultures.</b> They
        overall <b>manage their health well</b> and are among the <b>most likely to sustain positive health changes.</b>{' '}
        <br />
        <br />
        However, they also face some of the highest risks for asthma and depression.
      </>
    )
  },
  {
    name: 'Stable Status Quo',
    cohort: 'Moderately Resourced',
    socialMedia: ['Facebook'],
    descS: (
      <>
        Stable Status Quo individuals are <b>older, family-oriented homeowners.</b> They have some of the highest rates
        of <b>veterans,</b> and are often <b>politically engaged,</b> with above-average voter registration and some of
        the <b>highest donation rates to political causes.</b>
        <br />
        <br />
        They tend to be <b>less inclined to explore new cultural experiences</b> and have a lower interest in learning
        new things. While their educational attainment tends
      </>
    ),
    descL: (
      <>
        Stable Status Quo individuals are <b>older, family-oriented homeowners.</b> They have some of the highest rates
        of <b>veterans,</b> and are often <b>politically engaged,</b> with above-average voter registration and some of
        the <b>highest donation rates to political causes.</b>
        <br />
        <br />
        They tend to be <b>less inclined to explore new cultural experiences</b> and have a lower interest in learning
        new things. While their educational attainment tends to be below average, they fall within the{' '}
        <b>middle to upper-middle class</b> and are typically employed with <b>health insurance.</b>
        <br />
        <br />
        From a health perspective, this group has a <b>higher prevalence of smoking</b> and is at increased risk for
        chronic conditions such as <b>respiratory disease</b> and <b>diabetes.</b>
      </>
    )
  },
  {
    name: 'Right on Main Street',
    cohort: 'Moderately Resourced',
    socialMedia: ['Facebook'],
    descS: (
      <>
        Right on Main Street primarily consists of <b>middle-class couples,</b> many of whom have children. They tend to
        live in larger households, are<b> family-oriented,</b> and are <b>often married.</b>
        <br />
        <br />
        This group has average levels of educational attainment, <b>above-average voter registration. </b>Many are keen
        learners and
      </>
    ),
    descL: (
      <>
        Right on Main Street primarily consists of <b>middle-class couples,</b> many of whom have children. They tend to
        live in larger households, are<b> family-oriented,</b> and are <b>often married.</b>
        <br />
        <br />
        This group has average levels of educational attainment, <b>above-average voter registration. </b>Many are keen
        learners and <b>tech savvy.</b> Overall, they are in generally <b>good health,</b> While the majority earn a
        middle-class salary, they tend to have the lowest discretionary income compared to other groups.
        <br />
        <br />
        They are more likely to seek care at <b>community health centers</b> or <b>retail clinics,</b> live in
        communities with below-average broadband access, and are the most likely to use <b>alternative therapies.</b>
      </>
    )
  },
  {
    name: 'Middle of the Road',
    cohort: 'Moderately Resourced',
    socialMedia: ['Instagram', 'Twitter'],
    descS: (
      <>
        Middle of the Road individuals are <b>working-class professionals</b> with mixed educational attainment. They
        often <b>rent condos, apartments, or single-family homes.</b>
        <br />
        <br />
        Open to new experiences, this group <b>embraces novelty</b> – from cultural exploration to risk-taking. They are
        more likely to <b>live alone</b> and go <b>unmarried</b> than average and are
      </>
    ),
    descL: (
      <>
        Middle of the Road individuals are <b>working-class professionals</b> with mixed educational attainment. They
        often <b>rent condos, apartments, or single-family homes.</b>
        <br />
        <br />
        Open to new experiences, this group <b>embraces novelty</b> – from cultural exploration to risk-taking. They are
        more likely to <b>live alone</b> and go <b>unmarried</b> than average and are <b>less religious</b> than other
        groups.
        <br />
        <br /> Technologically fluent, they are <b>generally in good health,</b> though they have{' '}
        <b>slightly elevated risk for smoking and drug use.</b>
        <br />
        <br />
        When they seek out care, they often choose <b>community health centers</b> or <b>retail health clinics,</b> as
        opposed to traditional primary care providers.
      </>
    )
  },
  {
    name: 'Settled Homeowners',
    cohort: 'Resource Secure',
    socialMedia: ['Twitter'],
    descS: (
      <>
        Established Residents are primarily <b>community-engaged</b> individuals living in{' '}
        <b>high-earning households with above-average educational attainment.</b> Economically well-off, They are among
        the <b>most likely to own a home.</b>
        <br />
        <br />
        Quite connected, they have one of the <b>highest rates of donations</b> to political causes. They are the{' '}
        <b>most likely to be married</b> and with above average household sizes, family is a top priority. They are also
      </>
    ),
    descL: (
      <>
        Established Residents are primarily <b>community-engaged</b> individuals living in{' '}
        <b>high-earning households with above-average educational attainment.</b> Economically well-off, They are among
        the <b>most likely to own a home.</b>
        <br />
        <br />
        Quite connected, they have one of the <b>highest rates of donations</b> to political causes. They are the{' '}
        <b>most likely to be married</b> and with above average household sizes, family is a top priority. They are also
        more likely to have an elderly parent living with them.
        <br />
        <br /> In terms of their health, while they have some of the <b>lowest lifestyle risks</b> (i.e. drug, alcohol,
        and smoking), they have <b>above-average risk scores for cancer and musculoskeletal disorders.</b>
      </>
    )
  },
  {
    name: 'Metropolitan Comforts',
    cohort: 'Resource Secure',
    socialMedia: ['Twitter'],
    descS: (
      <>
        Metropolitan Comforts value family – whether as <b>active parents</b> or <b>retirees</b> whose children have
        left home.
        <br />
        <br /> With an average net worth of more than double the national average and nearly{' '}
        <b>half holding a bachelor’s degree or higher,</b> their <b>above-average financial stability</b> provides a
        strong foundation
      </>
    ),
    descL: (
      <>
        Metropolitan Comforts value family – whether as <b>active parents</b> or <b>retirees</b> whose children have
        left home.
        <br />
        <br /> With an average net worth of more than double the national average and nearly{' '}
        <b>half holding a bachelor’s degree or higher,</b> their <b>above-average financial stability</b> provides a
        strong foundation to support their families.
        <br />
        <br /> While generally well-resourced, Metropolitan Comforts are
        <b> at risk for some chronic conditions</b> and generally are{' '}
        <b>not the most attuned with using digital health tools</b> and sustaining wellness changes.
      </>
    )
  },
  {
    name: 'Strollers and Starter Homes',
    cohort: 'Resource Secure',
    socialMedia: ['Twitter'],
    descS: (
      <>
        Strollers and Starter Homes are more likely to have children, own homes, and earn higher-than-average incomes.
        <br />
        <br />
        As the group <b>most likely to have children</b> and the <b>largest household size,</b> they are family
        homeowners, with the highest percentage of households <b>earning over $200,000 annually. </b>In addition
      </>
    ),
    descL: (
      <>
        Strollers and Starter Homes are more likely to have children, own homes, and earn higher-than-average incomes.
        <br />
        <br />
        As the group <b>most likely to have children</b> and the <b>largest household size,</b> they are family
        homeowners, with the highest percentage of households <b>earning over $200,000 annually. </b>In addition to
        their family values, they are often <b>engaged politically,</b> <b>tech savvy,</b> and constantly{' '}
        <b>learning.</b>
        <br />
        <br />
        They are likely to use wearable health devices and engage with their health data, and they tend to{' '}
        <b>have lower risk for many chronic conditions,</b> including hypertension, asthma and diabetes.
        <br />
        <br /> However, despite their engagement, they also have one of the <b>highest smoking risk</b> and are{' '}
        <b>less likely than average to follow prescribed treatment plans</b> – suggesting convenience and motivation,
        rather than access, may be primary barriers to sustained health behavior change.
      </>
    )
  },
  {
    name: 'Established Empty-Nesters',
    cohort: 'Resource Secure',
    socialMedia: ['Twitter'],
    descS: (
      <>
        Established Empty-Nesters are <b>well educated</b> and <b>financially secure,</b> with the highest net worth of
        any group. <br />
        <br />
        While their children have typically grown up and left home, nearly one in five lives with an{' '}
        <b>elderly parent.</b> They have some of the highest rates of <b>health insurance coverage</b> and live in areas
        well-resourced with
      </>
    ),
    descL: (
      <>
        Established Empty-Nesters are <b>well educated</b> and <b>financially secure,</b> with the highest net worth of
        any group. <br />
        <br />
        While their children have typically grown up and left home, nearly one in five lives with an{' '}
        <b>elderly parent.</b> They have some of the highest rates of <b>health insurance coverage</b> and live in areas
        well-resourced with primary care providers.
        <br />
        <br /> They are least likely to suffer from depression, perhaps due to their{' '}
        <b>strong social connection and financial position.</b> They make efforts to maintain healthy habits such as
        diet and exercise, though they can struggle with adhering to lifestyle changes and adopting new routines.
        <br />
        <br />
        Despite their many advantages, they face some of the <b>highest rates of alcohol use</b> – and they have above
        average risk of comorbidities such as <b>diabetes and high blood pressure.</b>
      </>
    )
  },
  {
    name: 'Educated Cosmopolitans',
    cohort: 'Resource Secure',
    socialMedia: ['Twitter'],
    descS: (
      <>
        Educated Cosmopolitans are <b>high-earning professionals </b>and often speak{' '}
        <b>English as a second language. </b>They are energized by cultural connection and a desire to{' '}
        <b>seek out novelty</b> in their lives.
        <br />
        <br /> As the most educated group, <b>over 60%</b> have earned a <b>bachelor’s degree or higher</b> and
      </>
    ),
    descL: (
      <>
        Educated Cosmopolitans are <b>high-earning professionals </b>and often speak{' '}
        <b>English as a second language. </b>They are energized by cultural connection and a desire to{' '}
        <b>seek out novelty</b> in their lives.
        <br />
        <br /> As the most educated group, <b>over 60%</b> have earned a <b>bachelor’s degree or higher</b> and they are
        the most likely to be <b>continuous learners</b> throughout their lives. Often <b>tech savvy</b> and
        well-connected, Educated Cosmopolitans have the <b>highest rates of broadband access</b> of any persona.
        <br />
        <br /> They primarily consist of <b>married parents</b> living in their own high-value condos, apartments, or
        single-family homes.
      </>
    )
  }
]

export default PersonaDesc
